import axios from "axios";
import { Config } from "../../data/config";

export const SET_ADDRESS = "SET_ADDRESS";
export const setBuildingAddress = address => {
  return { type: SET_ADDRESS, payload: address };
};

export function getBuildings(code) {
  return function (dispatch) {
    axios
      .get(`${Config.frontApiUrl}/availability/services/${code}/buildings`)
      .then(response => {
        dispatch(setBuildingAddress(response.data.results));
      });
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/buildings-by-service-available.js